import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { Chat } from '../Chat'

@InputType()
export class AssignChatArgs extends ActionArgs {
  @Field(() => ID)
  chatId: string

  // Nullable — omitting it unassigns the conversation.
  @Field(() => ID, { nullable: true })
  assigneeId?: string
}

export interface IAssignChat extends IAction<Chat, AssignChatArgs> {}
